__webpack_require__.b = (typeof document !== 'undefined' && document.baseURI) || self.location.href;

// no installed chunks

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

// no on chunks loaded

// no jsonp function